import * as React from "react";
const SvgArrowDown1 = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "arrow-down-1_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M12 19.5a2.3 2.3 0 0 1-1.729-.78L.46 7.568a1.847 1.847 0 0 1 2.773-2.439l8.579 9.752a.25.25 0 0 0 .376 0l8.579-9.752a1.847 1.847 0 1 1 2.773 2.439l-9.808 11.148A2.3 2.3 0 0 1 12 19.5" }));
export { SvgArrowDown1 as ReactComponent };
